import { Injectable, OnDestroy, inject } from '@angular/core';
import { StoredStateHelper } from './stored-state.service';
import { BehaviorSubject, map, of, switchMap, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DealSoundService implements OnDestroy {

  private stateHelper = inject(StoredStateHelper)
  private updateSubject = new BehaviorSubject<boolean|undefined>(undefined)
  private defaultFlag = false

  readonly flag$ = this.updateSubject.pipe(
    switchMap(flag => {
      if (flag == undefined) {
        return this.stateHelper.getTerminalDealsSound().pipe(
          tap(flag => {
            if (flag !== this.updateSubject.value) {
              this.updateSubject.next(flag)
            }
          })
        )
      }
      return of(flag)
    }),
    map(flag => flag ?? this.defaultFlag),
  )

  get flag() {
    return this.updateSubject.value
  }

  setFlag(flag: boolean) {
    // защита от дублирования
    if (this.updateSubject.value !== flag) {
      this.stateHelper.setTerminalDealsSound(flag)
      this.updateSubject.next(flag)
    }
  }

  ngOnDestroy() {
    this.updateSubject.complete()
  }

}
